"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIGHT_SHOW_START_DELAY_MS = exports.ANIMATION_SAFE_AREA = exports.AnimationTimings = exports.CUSTOM_LOOK_NAMES = exports.CustomLookIds = exports.PatternIds = exports.PatternMotions = exports.SolidMotions = exports.LightShowSpeeds = void 0;
/**
 * SET.Live light show (ENG-2291): during a show, fans' phones display a
 * full-screen color, pattern or custom look so the crowd becomes part of the
 * light show. Looks are set up in the editor, published with the event, and
 * triggered live from Backstage through {@link LightShowLive}.
 */
exports.LightShowSpeeds = ["slow", "medium", "fast"];
exports.SolidMotions = ["none", "fade", "pulse", "twinkle"];
exports.PatternMotions = [
    "none",
    "scrollUp",
    "scrollDown",
    "radiate",
];
exports.PatternIds = [
    "keyboard",
    "wavelength",
    "radial",
    "stars",
    "stripes",
    "chevrons",
    "digital",
    "hearts",
    "triangles",
    "lightning",
    "emoji",
    "confetti",
];
/**
 * Custom looks are designed pieces with nothing to set up: each draws itself
 * (see ./custom), including its own colors and motion.
 */
exports.CustomLookIds = [
    "homeFree",
    "homeFreeMulticolor",
    "homeFreeTwinkle",
    "homeFreeCassette",
    "syncTest",
];
exports.CUSTOM_LOOK_NAMES = {
    homeFree: "Home Free",
    homeFreeMulticolor: "Home Free Multicolor",
    homeFreeTwinkle: "Home Free Twinkle",
    homeFreeCassette: "Home Free Cassette",
    syncTest: "Sync Test",
};
/**
 * "sync": every phone shows the same frame. "random": each phone plays from
 * its own point in the loop, so across the crowd it looks random.
 */
exports.AnimationTimings = ["sync", "random"];
/**
 * The part of a 1080×2340 animation that shows on phones from 9:16 to 9:21;
 * outside it may be cropped.
 */
exports.ANIMATION_SAFE_AREA = {
    left: 40,
    top: 210,
    width: 1000,
    height: 1920,
};
/**
 * How far ahead of a show runner's tap a change takes effect, so every phone
 * has the update before it starts and switches on the same frame.
 */
exports.LIGHT_SHOW_START_DELAY_MS = 1000;
//# sourceMappingURL=index.js.map